import { SVGProps } from "react";
import AnwenderbarAnPrallerSonne from "./attributes/Anwendbar_an_praller_Sonne.svg";
import BesondersSchnelleAbdunstung from "./attributes/Besonders_schnelle_Abdunstung.svg";
import BiologischAbbaubar from "./attributes/Biologisch_abbaubar.svg";
import Bis20ProzentVerduennungMoeglich from "./attributes/Bis_20_Prozent_Verduennung_moeglich.svg";
import DirektAufRost from "./attributes/Direkt_auf_Rost.svg";
import EigeneRezeptur from "./attributes/Eigene_Rezeptur.svg";
import EinfacheHandhabungDaKennzeichnungsfrei from "./attributes/Einfache_Handhabung_da_kennzeichnungsfrei.svg";
import EntferntSilikonUndKleberueckstaende from "./attributes/Entfernt_Silikon-und_Kleberueckstaende.svg";
import EntwickeltFurInvento1KPrimer from "./attributes/Entwickelt_fuer_Invento_1-K_Primer.svg";
import EntwickeltFurInventoICPundICS from "./attributes/Entwickelt_fuer_Invento_ICP_und_ICS.svg";
import EntwickeltFurInventoNBS from "./attributes/Entwickelt_fuer_Invento_NBS-Silikon.svg";
import ErfrischenderPolarCleanDuft from "./attributes/Erfrischender_Polar_Clean_Duft_.svg";
import ErmoeglichtHochwertigeBerflaechen from "./attributes/Ermoeglicht_hochwertige_berflaechen.svg";
import ErmoeglichtHochwertigeOberflaechen from "./attributes/Ermoeglicht_hochwertige_Oberflaechen_1.svg";
import ExtremDruckUndHitzbestaendig from "./attributes/Extrem_druck- und_hitzebestaendig.svg";
import FoerdertLanglebigenGummi from "./attributes/Foerdert_langlebigen_Gummi.svg";
import FreiVonAcetonUndPetroleum from "./attributes/Frei von_Aceton und_Petroleum.svg";
import FreiVonAcetonUndPetroleum1 from "./attributes/Frei von_Aceton und_Petroleum_1.svg";
import FreiVonMikroplastik from "./attributes/Frei_von_Mikroplastik.svg";
import FreiVonSilikon from "./attributes/Frei_von_Silikon.svg";
import FuerSommerUndWinter from "./attributes/Fuer Sommer_und_Winter.svg";
import FuerAlleSilikoneGeeignet from "./attributes/Fuer_alle_Silikon_geeignet.svg";
import FuerDiePerfekteVerarbeitung from "./attributes/Fuer_die_perfekte_Verarbeitung.svg";
import FuerTiefschwarzeGummiteile from "./attributes/Fuer_tiefschwarze_Gummiteile.svg";
import FusselfreiUndWeich from "./attributes/Fusselfrei_und_weich.svg";
import GeeignetFuerLederUndStoff from "./attributes/Geeignet fuer Leder und Stoff.svg";
import GeeignetFuerOelabschneider from "./attributes/Geeignet_fuer_Oelabschneider.svg";
import GleichmaessigeAbgabeBeiPolitur from "./attributes/Gleichmaessige_Abgabe_bei_Politur.svg";
import GreiftOberflaechenNichtAn from "./attributes/Greift_Oberflaechen_nicht_an.svg";
import GutFuerDieUmwelt from "./attributes/Gut fuer_die Umwelt.svg";
import HitzebestaendigBis300GradC from "./attributes/Hitzebestaendig_bis 300GradC.svg";
import HochreinesZink90ProzentAnteil from "./attributes/Hochreines_Zink_90_Prozent_Anteil.svg";
import IdealFuerSanitaerUndIndustrie from "./attributes/Ideal_fuer_Sanitaer_und_Industrie.svg";
import KorrosionsschutzVerhindertKaltschweissen from "./attributes/Korrosionsschutz_verhindert_Kaltschweissen.svg";
import KostenguenstigUndEinfach from "./attributes/Kostenguenstig_und einfach.svg";
import KostenguenstigUndEinfach1 from "./attributes/Kostenguenstig_und einfach_1.svg";
import NassInNassAuftragung from "./attributes/Nass-in-Nass_Auftragung.svg";
import NebelfreiesSpritzen from "./attributes/Nebelfreies spritzen .svg";
import Neutralisation from "./attributes/Neutralisation.svg";
import NickelfreiUndFettfrei from "./attributes/Nickelfrei_und_fettfrei.svg";
import OhneWasserAnwendbar from "./attributes/Ohne_Wasser_anwendbar.svg";
import OptimaleOberflaechenVorbereitung from "./attributes/Optimale_Oberflaechen-vorbereitung.svg";
import PHWert from "./attributes/PH-Wert.svg";
import ReinigtPflegtUndSchutzt from "./attributes/Reinigt_pflegt und_schuetzt.svg";
import SaeureFrei from "./attributes/Saeure Frei.svg";
import SchnellTrocknend20Min from "./attributes/Schnell-trocknend_20 - 30 Min.svg";
import SchnelleTiefenreinigung from "./attributes/Schnelle_Tiefenreinigung.svg";
import SchnelleRueckstandsfreieReinigung from "./attributes/Schnelle_rueckstandsfreie_Reinigung.svg";
import SchonendUndEffizient from "./attributes/Schonend_und_effizient.svg";
import SchontUndPflegtDieHaut from "./attributes/Schont_und_pflegt_die_Haut.svg";
import ServiceProduktFuerAlleMonteure from "./attributes/Service-Produkt_fuer_alle_Monteure.svg";
import SicherFuerElektrischeKontakte from "./attributes/Sicher_fuer_elektrische_Kontakte.svg";
import SpritzenOhneAbluftanlage from "./attributes/Spritzen_ohne_Abluftanlage.svg";
import StarkKalkLoesend from "./attributes/Stark_Kalk_loesend.svg";
import StaubtrockenNach10Min from "./attributes/Staubtrocken_nach_10 Min.svg";
import SwissMade from "./attributes/Swiss Made.svg";
import TiefenwirksamBis5Cm from "./attributes/Tiefenwirksam_bis_5cm.svg";
import TropfsicherUndTransparent from "./attributes/Tropfsicher_und_transparent.svg";
import UeberlegeneHaftung from "./attributes/Ueberlegene_Haftung.svg";
import UnterstuetztDieNachhaltigeDesinfektion from "./attributes/Unterstuetzt die_nachhaltige_Desinfektion.svg";
import UmweltschonendUndFreiVonVOC from "./attributes/VOC Frei.svg";
import ZumAbsauernVonMetallen from "./attributes/Zum Absaeuern_von_Metallen.svg";
import OhneSandstrahlenAnwendbar from "./attributes/ohne Sandstrahlen_anwendbar.svg";
import Verdunnbar from "./attributes/verduennbar.svg";
import VerschiedeneRALFarben from "./attributes/verschiedene_RAL-Farben.svg";

const slugMapping: Record<string, (props: SVGProps<SVGSVGElement>) => React.JSX.Element> = {
  "anwendbar-an-praller-sonne": AnwenderbarAnPrallerSonne,
  "besonders-schnelle-abdunstung": BesondersSchnelleAbdunstung,
  "biologisch-abbaubar": BiologischAbbaubar,
  "bis-zu-5-fach-verdunnbar": Verdunnbar,
  "direkt-auf-rost": DirektAufRost,
  "eigene-rezeptur": EigeneRezeptur,
  "einfache-handhabung-da-kennzeichnungsfrei": EinfacheHandhabungDaKennzeichnungsfrei,
  "entfernt-silikon-und-kleberuckstande": EntferntSilikonUndKleberueckstaende,
  "entwickelt-fur-invento-1-k-primer": EntwickeltFurInvento1KPrimer,
  "entwickelt-fur-invento-icp-und-ics": EntwickeltFurInventoICPundICS,
  "entwickelt-fur-invento-nbs-silikon": EntwickeltFurInventoNBS,
  "erfrischender-polar-clean-duft": ErfrischenderPolarCleanDuft,
  "ermoglicht-hochwertige-oberflachen": ErmoeglichtHochwertigeBerflaechen,
  "extrem-druck-und-hitzebestandig": ExtremDruckUndHitzbestaendig,
  "extrem-hohe-deckkraft": UeberlegeneHaftung,
  "fordert-langlebigen-gummi": FoerdertLanglebigenGummi,
  "frei-von-aceton-und-petroleum": FreiVonAcetonUndPetroleum,
  "frei-von-aceton-und-petroleum-1": FreiVonAcetonUndPetroleum1,
  "frei-von-mikroplastik": FreiVonMikroplastik,
  "frei-von-silikon": FreiVonSilikon,
  "fur-sommer-und-winter": FuerSommerUndWinter,
  "fur-alle-silikone-geeignet": FuerAlleSilikoneGeeignet,
  "fur-die-perfekte-verarbeitung": FuerDiePerfekteVerarbeitung,
  "fur-tiefschwarze-gummiteile": FuerTiefschwarzeGummiteile,
  "fusselfrei-und-weich": FusselfreiUndWeich,
  "geeignet-fur-leder-und-stoff": GeeignetFuerLederUndStoff,
  "geeignet-fur-olabschneider": GeeignetFuerOelabschneider,
  "gleichmassige-abgabe-bei-politur": GleichmaessigeAbgabeBeiPolitur,
  "greift-oberflachen-nicht-an": GreiftOberflaechenNichtAn,
  "gut-fuer-die-umwelt": GutFuerDieUmwelt,

  "hitzebestandig-bis-300-c": HitzebestaendigBis300GradC,
  "hochreines-zink-90-anteil": HochreinesZink90ProzentAnteil,
  "hochster-schutz-vor-korrosion": KorrosionsschutzVerhindertKaltschweissen,
  "ideal-fur-sanitar-und-industrie": IdealFuerSanitaerUndIndustrie,
  "keine-kunstlichen-duftstoffe": GutFuerDieUmwelt,
  "korrosionsschutz-verhindert-kaltschweissen": KorrosionsschutzVerhindertKaltschweissen,
  "kraftvolle-reinigung-fur-fast-alle-materialien": SchnelleTiefenreinigung,
  "langanhaltender-abperleffekt": ErmoeglichtHochwertigeOberflaechen,
  "langzeitschutz-des-lacks": GreiftOberflaechenNichtAn,
  "nass-in-nass-auftragung-moglich": NassInNassAuftragung,
  "naturlich-abbaubar-frei-von-voc": UmweltschonendUndFreiVonVOC,
  "nickelfrei-und-fettfrei": NickelfreiUndFettfrei,
  "ohne-wasser-anwendbar": OhneWasserAnwendbar,

  "optimale-oberflachenvorbereitung": OptimaleOberflaechenVorbereitung,
  "optimale-vorbereitung-vor-dem-lackaufbau": KorrosionsschutzVerhindertKaltschweissen,
  "pH-wert": PHWert,
  "produkt-biologisch-abbaubar": BiologischAbbaubar,
  "reinigt-versiegelt-glanzt": ErmoeglichtHochwertigeOberflaechen,
  "reinigt-pflegt-und-schutzt": ReinigtPflegtUndSchutzt,
  "schnelle-und-sichere-desinfektion": UnterstuetztDieNachhaltigeDesinfektion,
  "schonend-und-effizient": SchonendUndEffizient,
  "schont-und-pflegt-die-haut": SchontUndPflegtDieHaut,
  "service-produkt-fur-alle-monteure": ServiceProduktFuerAlleMonteure,
  "sicher-fur-elektrische-kontakte": SicherFuerElektrischeKontakte,
  "spritzen-ohne-abluftanlage": SpritzenOhneAbluftanlage,
  "staubtrocken-nach-10-min": StaubtrockenNach10Min,
  "staubtrocken-nach-3-minuten": SchnellTrocknend20Min,
  "stark-kalk-losend": StarkKalkLoesend,
  "streifenfrei-auf-glas-und-kunststoff": ErmoeglichtHochwertigeOberflaechen,
  "swiss-made": SwissMade,
  "tiefenreinigung-auf-fast-allen-materialien": SchnelleTiefenreinigung,
  "tiefenwirksam-bis-5-cm": TiefenwirksamBis5Cm,
  "trocknung-12-min-1825-c": SchnellTrocknend20Min,
  "trocknung-20-30-min-18-25-c": SchnellTrocknend20Min,
  "tropfsicher-und-transparent": TropfsicherUndTransparent,
  "uberlackierung-nach-30-minuten": Neutralisation,

  "uberlegene-haftung-auch-auf-kunststoff": UeberlegeneHaftung,
  "wasche-und-glanz-in-einem": SchnelleTiefenreinigung,
  "umweltschonend-und-frei-von-voc": UmweltschonendUndFreiVonVOC,
  "unterstutzt-die-nachhaltige-desinfektion": UnterstuetztDieNachhaltigeDesinfektion,
  "zum-absauern-von-metallen": ZumAbsauernVonMetallen,
  "ohne-sandstrahlen-anwendbar": OhneSandstrahlenAnwendbar,
  "bis-zu-50-fach-verdunnbar": Verdunnbar,
  "entfernt-starke-verschmutzungen": SchnelleTiefenreinigung,
  "entfernt-zementschleier-baustoffruckstande": ReinigtPflegtUndSchutzt,
  "entfernt-starkste-verschmutzungen-in-3-min": SchnelleTiefenreinigung,
  "freie-von-saure-und-voc": UmweltschonendUndFreiVonVOC,
  "grundliche-und-effiziente-reinigung": SchnelleTiefenreinigung,
  "haftet-an-oberflachen": UeberlegeneHaftung,
  "in-allen-ral-farbtonen-erhaltlich": VerschiedeneRALFarben,


  "biologisch-abbaubar-frei-von-voc": UmweltschonendUndFreiVonVOC,
  "frei-von-saure-und-voc": UmweltschonendUndFreiVonVOC,
  "hoher-spruhdruck-bis-1m": FreiVonAcetonUndPetroleum1,
  "schnelle-ruckstandsfreie-reinigung": SchnelleRueckstandsfreieReinigung,

  "besonders-schnell-und-kostengunstig": KostenguenstigUndEinfach,
  "dringt-tief-in-hohlraume": TiefenwirksamBis5Cm,
  "dringt-tief-in-hohlraume2": TiefenwirksamBis5Cm,

  "elastische-schicht-schutzt-vor-rost": KorrosionsschutzVerhindertKaltschweissen,

  "saeure-frei": SaeureFrei,
  "nebelfreies-spritzen": NebelfreiesSpritzen,

}


interface ProductAttributeProps extends SVGProps<SVGSVGElement> {
  slug: string;
}

function ProductAttribute(props: ProductAttributeProps) {
  const { slug } = props;
  const RelevantComponent = slugMapping[slug];

  if (!RelevantComponent) {
    console.error(`Cannot find the icon for slug: `, slug)
    return null;
  }

  return <RelevantComponent {...props} />
}

export default ProductAttribute;
